import { isNullOrUndefined } from '@uzurv/core';
import { cloneDeep } from 'lodash';
import { OperationsAlertType, RideMonitoringAlert, TransitProgramInfo } from '../models';

export class RideMonitoringUtil {
  static addOrReplaceAlertInList(alert: RideMonitoringAlert, alertList: Array<RideMonitoringAlert>): Array<RideMonitoringAlert> {
    const clonedAlert: RideMonitoringAlert = cloneDeep(alert);
    const clonedAlertList: Array<RideMonitoringAlert> = cloneDeep(alertList);

    if (isNullOrUndefined(clonedAlert)) {
      return clonedAlertList;
    }

    const existingIndex = alertList.findIndex(r => r.operationAlertId === alert.operationAlertId);

    if (existingIndex === -1) {
      clonedAlertList.push(clonedAlert);
    } else {
      clonedAlertList.splice(existingIndex, 1, clonedAlert);
    }

    return clonedAlertList;
  }

  static sortOperationsAlertTypes(operationsAlertTypes: Array<OperationsAlertType>): Array<OperationsAlertType> {
    return operationsAlertTypes.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
  }

  static sortTransitPrograms(transitPrograms: Array<TransitProgramInfo>): Array<TransitProgramInfo> {
    return transitPrograms.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
  }

  /**
   * Since duplicate alerts from a refreshed server list are modified in place, we sort locally again.
   * @param alerts
   * @param ascending
   */
  static sortRideMonitoringAlerts(alerts: Array<RideMonitoringAlert>, ascending: boolean = true): Array<RideMonitoringAlert> {
    if (ascending) {
      return alerts.sort((a, b) => a.operationsAlertCreatedDate.getTime() - b.operationsAlertCreatedDate.getTime());
    } else {
      return alerts.sort((a, b) => b.operationsAlertCreatedDate.getTime() - a.operationsAlertCreatedDate.getTime());
    }
  }

  /**
   * Simplifies pageNumber tracking when alternating between scroll fetching and refresh fetching.
   * @param alerts
   * @param pageSize
   */
  static calculatePageNumber(alerts: Array<RideMonitoringAlert>, pageSize: number): number {
    return Math.floor(alerts.length / pageSize);
  }
}
